import React from 'react'
import { useTranslation } from 'react-i18next'

import useStyles from './styles'
import useCommonStyles from '../../../styles/common/listPage'

function Help() {
  const { t } = useTranslation()

  const commonClasses = useCommonStyles()
  const classes = useStyles()

  return (
    <div className={commonClasses.heading}>
      <h3 className={commonClasses.title}>{t('Help')}</h3>
      <p>{t('If you have any questions or are experiencing technical issues, please email ')}</p>
      <p>
        <a className={classes.link} href="mailto:marcus@partnerbrite.com">
          marcus@partnerbrite.com
        </a>{' '}
        {t('for assistance.')}
      </p>
    </div>
  )
}

export default Help
